import { ReactElement } from 'react'
import { Stack, Typography } from '@mui/material'
import { CoordinatePointInput } from '@ui/forms'

interface Props {
  zDisabled?: boolean
}

const WallStartEndFields = ({ zDisabled = true }: Props): ReactElement => {
  return (
    <>
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography fontSize="inherit" color="red">
          Start
        </Typography>
        <CoordinatePointInput
          label="Start"
          name="start"
          pointManipulation={{ z: { disabled: zDisabled } }}
        />
      </Stack>

      <Stack direction="row" spacing={1} alignItems="center">
        <Typography fontSize="inherit">Ende</Typography>
        <CoordinatePointInput
          label="Ende"
          name="end"
          pointManipulation={{ z: { disabled: zDisabled } }}
        />
      </Stack>
    </>
  )
}

export default WallStartEndFields
